<template>
  <q-dialog
    v-model="dialog"
    :persistent="persistent"
    :maximized="fullscreen"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="dialog">
      <q-card-section class="dialog__header">
        <div class="text-h6">{{ title }}</div>
        <q-btn
          round
          flat
          unelevated
          no-caps
          icon="close"
          color="secondary"
          @click.native="close"
        />
      </q-card-section>

      <q-card-section class="dialog__content">
        <slot />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    title: String,
    fullscreen: Boolean,
    persistent: Boolean,
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialog {
  height: 100%;
  width: 100%;
  max-height: 100vh;
  max-width: 100vw;
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    padding: 12px 15px;
    border-bottom: 0.5px solid #ececec;
    span {
      font-weight: 700;
    }
  }
  &__content {
    display: flex;
    width: 100%;
    height: calc(100% - 65px);
  }
}
</style>
